import { useRouter } from 'expo-router';
import { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button } from 'react-native-paper';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { AppSearchbar } from '@/components/atoms';
import { ContactList } from '@/components/organisms';
import { useDebounce } from '@/hooks';
import { useTranslation } from '@/i18n';
import { useAppTheme } from '@/theme';

export const ContactSearch = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const theme = useAppTheme();
  const insets = useSafeAreaInsets();
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query.trim(), 300);

  const handlePress = useCallback(
    (id: number) => {
      router.back();
      setTimeout(() => {
        router.push(`/contact/${id}`);
      }, 0);
    },
    [router],
  );

  return (
    <View style={[styles.container, { paddingTop: insets.top }]}>
      <View style={styles.header}>
        <AppSearchbar
          placeholder={t('common.search')}
          onChangeText={setQuery}
          value={query}
          autoFocus
          elevation={0}
          placeholderTextColor={theme.colors.textNdMuted}
          inputStyle={{ color: theme.colors.textNdPrimary }}
          style={[
            styles.searchBar,
            {
              backgroundColor: theme.colors.background,
              borderWidth: 1,
              borderColor: theme.colors.textNdPrimary,
            },
          ]}
        />
        <Button onPress={() => router.back()}>{t('common.cancel')}</Button>
      </View>
      {query.trim().length > 0 && debouncedQuery.length > 0 && (
        <ContactList searchQuery={debouncedQuery} onPress={handlePress} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingBottom: 8,
    paddingTop: 8,
  },
  searchBar: {
    flex: 1,
  },
});
